import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { registerUser } from "../store/authSlice";
import { useNavigate, Link } from "react-router-dom";
import "../index.css"; // to include the animated camo
import ParticlesBg from "particles-bg";

const Register = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((state) => state.auth);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
  });

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await dispatch(registerUser(formData));
    if (result.meta.requestStatus === "fulfilled") {
      navigate("/dashboard");
    }
  };

  return (
    <>
          <ParticlesBg type="circle" margin="5px" bg={true} />

    <div
      className="register-page"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        background: "transparent",
      }}
    >
      <div
        className="register-card"
        style={{
          background: "rgba(255, 255, 255, 0.08)",
          backdropFilter: "blur(10px)",
          borderRadius: "16px",
          boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
          padding: "40px",
          width: "90%",
          maxWidth: "420px",
          color: "#fff",
          textAlign: "center",
          animation: "fadeInUp 1s ease-out",
        }}
      >
        <h2
          style={{
            marginBottom: "25px",
            fontWeight: "bold",
            fontSize: "1.8rem",
            letterSpacing: "1px",
          }}
        >
          Create Account
        </h2>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Full Name"
            value={formData.name}
            onChange={handleChange}
            required
            style={inputStyle}
          />
          <input
            type="email"
            name="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={handleChange}
            required
            style={inputStyle}
          />
          <input
            type="password"
            name="password"
            placeholder="Password (min 8 chars)"
            value={formData.password}
            onChange={handleChange}
            required
            style={inputStyle}
          />

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              padding: "12px",
              background: "#1e88e5",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              fontWeight: "bold",
              cursor: "pointer",
              letterSpacing: "0.5px",
              boxShadow: "0 0 10px rgba(30,136,229,0.4)",
              transition: "0.3s all",
            }}
            onMouseOver={(e) =>
              (e.target.style.boxShadow = "0 0 15px rgba(30,136,229,0.8)")
            }
            onMouseOut={(e) =>
              (e.target.style.boxShadow = "0 0 10px rgba(30,136,229,0.4)")
            }
          >
            {loading ? "Registering..." : "Register"}
          </button>
        </form>

        {error && <p style={{ color: "#ff8080", marginTop: "10px" }}>{error}</p>}

        <p style={{ marginTop: "20px" }}>
          Already have an account?{" "}
          <Link
            to="/login"
            style={{ color: "#64b5f6", textDecoration: "none", fontWeight: "bold" }}
          >
            Login
          </Link>
        </p>
      </div>
    </div>
    </>
  );
};

const inputStyle = {
  width: "100%",
  padding: "10px",
  marginBottom: "15px",
  borderRadius: "6px",
  border: "1px solid rgba(255,255,255,0.3)",
  background: "rgba(255,255,255,0.1)",
  color: "#fff",
  outline: "none",
};

export default Register;
